module.exports = __webpack_public_path__ + "static/media/MANGO.7a13a27d.svg";